__turbopack_context__.v({
  "trustpilotSupportRichText": "_2xkssa_trustpilotSupportRichText",
  "trustpilotWrapper": "_2xkssa_trustpilotWrapper",
});
